class VideoResponser {
  constructor(video) {
    var $video = video;
    this.options = {
      video,
      breakpoints: { default: { src: $video.getAttribute("data-src") } },
    };

    // get a list of video switching points and links to the videos themselves
    $video.querySelectorAll("[data-src]").forEach(
      (element) =>
        (this.options.breakpoints[element.getAttribute("data-mw")] = {
          src: element.getAttribute("data-src"),
        }),
    );
    $video.innerHTML = ""; // we clean up so that there is nothing superfluous

    // run the handler and track the change in screen width
    this.responseVideo(this.options);
    this.resizer();
  }

  /** Function runs on resize  */
  resizer() {
    window.addEventListener("resize", () => this.responseVideo(this.options));
  }

  /**
   * Change src value of video link to fit screen width
   *
   * @param {Object} options object with options
   */
  responseVideo(options) {
    const { video, breakpoints } = options; // get options
    var $video = video;
    const widthNow = $video.getAttribute("data-width-now") || null;
    const maxBreakpoint = Math.max.apply(
      Math,
      Object.keys(breakpoints)
        .filter((key) => key <= document.body.clientWidth)
        .map(Number),
    );
    let nowBreakpoint = "default"; // choose either the maximum value, if not, then the default
    if (maxBreakpoint && maxBreakpoint != "-Infinity") {
      nowBreakpoint = maxBreakpoint;
    }

    if (widthNow && widthNow == nowBreakpoint) return; // check if the video needs to be changed

    $video.setAttribute("data-width-now", nowBreakpoint);
    $video.src = breakpoints[nowBreakpoint].src;
  }
}

(function ($) {
  var heights = [];
  var mainHeight = 0;
  var padding = 0;
  var swiper = null;
  var windowWidth = 0;
  window.translateX = 0;
  window.sellingFast = 10;
  window.fewLeft = 5;
  window.fewLeftMin = 3;

  $(document).on("click", function (event) {
    if (
      !$(event.target).closest("header-menu").length &&
      !$(event.target).closest(".cart-btn").length
    ) {
      closeOpen(null);
    }
  });

  $(document).ready(function () {
    padding = $("body.index").length > 0 ? 40 : 0;

    showNewsletterPopup();
    initSwiper();
    bindEvents();
    updateHeights();
    checkMobile();
    checkZero();
    checkCartCount();
    removeTrailingZeroes();
    var cols = $(".mega-menu__list > li").length - 1;
    $(".mega-menu__list").css(
      "grid-template-columns",
      "2fr repeat(" + cols + ", auto)",
    );

    $(".responsive-video").each((index, element) => {
      new VideoResponser($(element).get(0));
    });
    initCollapsibleGA();
  });

  $(window).load(function () {
    setMainHeight();

    new ResizeSensor(jQuery("#MainContent"), function () {
      if ($("footer").data("Footer")) {
        $("footer").data("Footer").checkBottom();
      }
    });
  });

  $(window).scroll(function (event) {
    if ($(window).width() > 767) {
      return;
    }

    navUp();
  });

  var lastScrollTop = 0;

  function navUp() {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > lastScrollTop) {
      $(".account-navi, .top-part").addClass("nav-up");
    } else if (scrollTop < lastScrollTop) {
      $(".account-navi, .top-part").removeClass("nav-up");
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }

  $(window).resize(
    debounce(function (e) {
      if (windowWidth == 0 || windowWidth == $(window).width()) {
        checkMobile();
        windowWidth = $(window).width();
        return;
      }

      setMainHeight();
      checkMobile();

      windowWidth = $(window).width();
    }),
  );

  /**
      A function to remove the trailing zeroes. Using the currency formatter doesn't work ideally
    */
  function removeTrailingZeroes() {
    var prices = document.querySelectorAll(".price-item");
    if (!prices) return;
    for (var each of prices) {
      each.innerText = each.innerText.replace(".00", "");
    }
  }

  function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
    // expires.setTime(expires.getTime() + (expiry * 1000));
    document.cookie =
      key + "=" + value + ";path=/;expires=" + expires.toUTCString();
  }

  function getCookie(key) {
    var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
    return keyValue ? keyValue[2] : null;
  }

  function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, "-1");
  }

  function setPoupCookie() {
    setCookie("newsletter-popup", 1, window.show_again_delay);
  }

  function getPoupCookie() {
    return getCookie("newsletter-popup");
  }

  function showNewsletterPopup() {
    if (window.location.href.indexOf("challenge") >= 0) return;

    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get("customer_posted");
    const formType = urlParams.get("form_type");

    if (formType != null && $(".already-signed").length > 0) {
      $(".already-signed").show();
    }

    if (customerPosted == "true" || formType) {
      $(".newsletter-popup-section").show();
      setPoupCookie();
    } else {
      if (getPoupCookie()) return;

      setTimeout(function () {
        $(".newsletter-popup-section").show();
      }, window.popup_delay * 1000);
    }
  }

  function isMobile() {
    return $(window).width() < 767;
  }

  function checkMobile() {
    if (isMobile()) {
      $("#Details-HeaderMenu-Search").addClass("mobile");
      $("#Details-HeaderMenu-Cart").addClass("mobile");
      $(".predictive-search").addClass("mobile");

      // if (swiper) {
      //     swiper.destroy(true, true);
      // }

      // $('.product-form-wrapper').css('top', $('.product-form-wrapper').offset().top + 'px');
    } else {
      $("#Details-HeaderMenu-Search").removeClass("mobile");
      $("#Details-HeaderMenu-Cart").removeClass("mobile");
      $(".predictive-search").removeClass("mobile");
      // $('.product-form-wrapper').css('top', '');

      initSwiper();
    }
  }

  function closeMobileMenu() {
    $("#Details-menu-drawer-container > summary").attr("aria-expanded", false);
    $("#Details-menu-drawer-container").removeClass("menu-opening");
    $("body").removeClass("overflow-hidden-tablet");

    setTimeout(function () {
      $("#Details-menu-drawer-container").removeAttr("open");
    }, 500);
  }

  function closeSearch() {
    $("#Details-HeaderMenu-Search").removeClass("open");
    $("body").css("overflow", "");
  }

  function bindEvents() {
    $(document).on(
      "click",
      ".product-form__error-message-wrapper, .cart-item__error",
      function () {
        $(this).attr("hidden", "");
      },
    );

    $(".search__input.field__input").focus(function () {
      $(this).parent().addClass("focus");
    });

    $(".search__input.field__input").blur(function () {
      $(this).parent().removeClass("focus");
    });

    $(".img-bracket-wrapper[data-href]").click(function () {
      var url = $(this).data("href");
      window.location.href = url;
    });

    $(".password .forgot").click(function () {
      $(".recover-popup").addClass("active");
    });

    $(".recover-popup .close, .recover-popup .cancel-forgot").click(
      function () {
        $(".recover-popup").removeClass("active");
      },
    );

    $(".newsletter-popup-section .close").click(function () {
      var parent = $(this).closest(".newsletter-popup-section ");
      parent.hide();
      setPoupCookie();
    });

    $(".menu-drawer__search").click(function () {
      closeMobileMenu();

      $("body").css("overflow", "hidden");

      setTimeout(function () {
        $("#Details-HeaderMenu-Search").addClass("open");
      }, 500);
    });

    $("#Details-HeaderMenu-Search .close-wrapper").click(function () {
      closeSearch();
    });

    $("[data-close='search-modal']").click(function () {
      closeSearch();
    });

    $(".password img").click(function () {
      var input = $(this).closest(".password").find("input");
      if (input.attr("type") == "password") {
        input.attr("type", "text");
        input.addClass("show-password");
      } else {
        input.attr("type", "password");
        input.removeClass("show-password");
      }
    });

    $(".header__cart:not(.open)").click(function () {
      var drawer = $(this).find("cart-drawer");
      if (drawer.hasClass("active")) return;

      drawer.addClass("active");
    });

    // $('cart-drawer.drawer').on('DOMSubtreeModified', function(e) {
    //     if ($(e.target).is('#CartDrawer') || $(e.target).is('.drawer__inner')) {
    //         initSwiper();

    //         setTimeout(function() {
    //             checkErrors();
    //             $('.header__cart:not(.open) .header__menu-item').trigger('click');
    //         }, 250);
    //     }
    // });

    $("cart-drawer").appendTo("#MegaMenu-Content-Cart");
    $("cart-drawer").css("position", "relative");

    $(".input-checkbox label").click(function () {
      var parent = $(this).closest(".input-checkbox");
      var checkbox = parent.find('input[type="checkbox"]');
      if (checkbox.is(":checked")) {
        checkbox.prop("checked", false);
        return;
      }

      checkbox.prop("checked", true);
    });

    $(".cust-form form").submit(function (e) {
      e.preventDefault(); // avoid to execute the actual submit of the form.

      var form = $(this);
      var action = form.attr("action");

      $(".cust-form .errors").hide();
      $(".sign-in-button").attr("disabled", "");
      checkMainPosition($(this));

      $.post(action, form.serialize())
        .done(function (data) {
          var message = "";
          var errors = $(data).find(".errors ul li");
          // console.log(data);
          if (errors.length == 0) {
            errors = $(data).find(".form__message ~ ul > li");
          }

          errors.each((index, element) => {
            message += $(element).html() + "<br>";
          });

          if (message != "" && message != "undefined") {
            $(".cust-form .errors").html(message);
            $(".cust-form .errors").show();
            checkMainPosition(form);
          } else {
            document.location.href = "/account";
          }

          $(".sign-in-button").removeAttr("disabled");
        })
        .fail(function () {
          $(".sign-in-button").removeAttr("disabled");
        });
    });

    $(".cust-form input").on("change paste keyup", function (e) {
      validateForm();
    });

    $(".newsletter-form__field-wrapper input").on(
      "change paste keyup",
      function (e) {
        if (!$(this).val()) {
          $(this).parent().find("button").prop("disabled", true);
        } else {
          $(this).parent().find("button").prop("disabled", false);
        }
      },
    );

    $(".login-toggle span").click(function () {
      $(".login-toggle span").removeClass("active");
      $(this).addClass("active");

      $(".cust-form").toggleClass("sign-up");
      if ($(".cust-form").hasClass("sign-up")) {
        $(".cust-form form").attr("action", "/account");
      } else {
        $(".cust-form form").attr("action", "/account/login");
      }

      validateForm();
      checkMainPosition($(this));
    });

    $(".header__menu-item").click(function () {
      var isCart = $(this).closest(".header__cart").length > 0;
      if ((isCart && checkZero()) || (isCart && $("body.cart").length > 0)) {
        return;
      }

      if (isMobile()) {
        closeMobileMenu();
        closeSearch();
      }

      updateHeights();

      var mega = $(this).closest("header-menu").find(".mega-menu");
      closeOpen(mega);
      $(this).closest("header-menu").toggleClass("open");
      toggleMega(mega);
    });
  }

  function checkErrors() {
    $("cart-drawer .cart-item__error-text").each((index, element) => {
      if (!$(element).is(":empty")) {
        var parent = $(element).closest(".cart-item__media");
        parent.addClass("error");
      }
    });
  }

  window.onCartUpdated = function () {
    initSwiper();
    checkErrors();
    updateHeights();
    // moveContent($('.header__cart .mega-menu'), true);

    setTimeout(function () {
      var zero = checkZero();
      if (zero) {
        $(".header__cart.open .header__menu-item").trigger("click");
      }
    }, 250);

    if (!isMobile()) {
      $(".cart-icon-wrapper").addClass("active");
      setTimeout(function () {
        $(".cart-icon-wrapper").removeClass("active");
      }, 3000);
    }
  };

  function checkZero() {
    if (
      $(".cart-count-bubble > span:first-child").html() == 0 ||
      $(".cart-count-bubble").length == 0
    ) {
      $("#Details-HeaderMenu-Cart > .header__menu-item").addClass("zero");
      return true;
    }

    $("#Details-HeaderMenu-Cart > .header__menu-item").removeClass("zero");
    return false;
  }

  function checkCartCount() {
    $(document).click(
      ".header__cart .header__menu-item, .header__cart .cart",
      function (e) {
        var $this = $(".header__cart .header__menu-item");
        if ($this.hasClass("zero")) {
          $(".header__cart.open .header__menu-item").trigger("click");
          return;
        }
      },
    );
  }

  function setupFooter() {
    if ($("footer").data("Footer")) {
      $("footer").data("Footer").destroy();
    }

    $("footer").footer({
      content: "main",
      zIndexTop: 3,
    });
  }

  function initSwiper() {
    const swiperCardMedia = new Swiper(".swiper-media-container.swiper", {
      slidesPerView: 1,
      direction: "horizontal",
      spaceBetween: 0,
      freeMode: false,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
      },
      freeMode: {
        enabled: true,
        sticky: true,
      },
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    if (isMobile()) return;

    // var transform = null;
    // var element = document.querySelector('.swiper-wrapper');
    // console.log(element.style.transform);
    // if (element.style && element.style.transform) {
    //     transform = element.style.transform;
    //     console.log(transform);
    // }

    // if (swiper) {
    //     window.translateX = swiper.getTranslate();
    //     console.log(window.translateX);
    // }

    swiper = new Swiper("cart-drawer .cart-swiper", {
      slidesPerView: "auto",
      spaceBetween: 45,
      freeMode: true,
      preventClicks: true,
      noSwipingSelector: "button",
      a11y: false,
      on: {
        init: (swiper) => {
          updateHeights();
        },
        afterInit: (swiper) => {
          swiper.translateTo(window.translateX, 0, true, true);

          requestAnimationFrame(function () {
            swiper.translateTo(window.translateX, 0, true, true);
          });
        },
        setTranslate: (swiper, translate) => {
          if (translate == 0) return;
          window.translateX = translate;
        },
      },
    });
  }

  function debounce(func) {
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, 100, event);
    };
  }

  function checkMainPosition(element) {
    setTimeout(function () {
      var parent = element.closest(".mega-menu");
      updateHeights();
      moveContent(parent, true);
    }, 250);
  }

  function updateHeights() {
    heights = [];

    $(".mega-menu").each((index, element) => {
      var details = $(element).find(".mega-menu__content");
      heights.push({
        id: $(element).attr("id"),
        height: details.outerHeight(true),
      });
    });

    // console.log(heights);
  }

  function checkTerms() {
    if ($('input[name="subscribe"]').is(":checked")) {
      $('input[name="customer[accepts_marketing]"]').val("true");
      return;
    }

    $('input[name="customer[accepts_marketing]"]').val("false");
  }

  function validateForm() {
    checkTerms();

    var form = $(".cust-form");
    if (form.hasClass("sign-up")) {
      if (
        form.find('input[name="terms"]').is(":checked") &&
        form.find('input[name="customer[first_name]"]').val() &&
        form.find('input[name="customer[last_name]"]').val() &&
        form.find('input[name="customer[email]"]').val() &&
        form.find('input[name="customer[password]"]').val()
      ) {
        $("#sign-up").removeAttr("disabled");
        return;
      }

      $("#sign-up").attr("disabled", "");
      return;
    }

    if (
      form.find('input[name="customer[email]"]').val() &&
      form.find('input[name="customer[password]"]').val()
    ) {
      $("#login").removeAttr("disabled");
      return;
    }

    $("#login").attr("disabled", "");
  }

  function closeOpen(target) {
    var found = false;
    $(".mega-menu").each((index, element) => {
      if (target != null && $(element).get(0) == $(target).get(0)) return;
      var parent = $(element).closest("header-menu");
      if (parent.hasClass("open")) {
        found = parent;
      }
    });

    if (found) {
      found.toggleClass("open");
      var mega = found.find(".mega-menu");
      toggleMega(mega);
    }
  }

  function toggleMega(mega) {
    if ($(window).scrollTop() == 0 && !isMobile()) {
      moveContent(mega, false);
      checkScrollLock();
    } else {
      $("main").css("margin-top", "");
    }

    mega.toggleClass("open");

    setTimeout(function () {
      $("main").toggleClass("open");
    }, 500);
  }

  function isIndex() {
    return $("body.index").length > 0;
  }

  function checkScrollLock() {
    if (isIndex() || isMobile()) return;

    if ($("header-menu.open").length > 0) {
      $("body").addClass("overflow-hidden");
      $("main").css("opacity", 0.5);
      $("footer").hide();
      return;
    }

    $("body").removeClass("overflow-hidden");
    $("main").css("opacity", 1);

    setTimeout(function () {
      if ($("header-menu.open").length > 0) return;

      $("footer").show();
    }, 300);
  }

  function setMainHeight() {
    $("footer").hide();
    if ($("footer").data("Footer")) {
      $("footer").data("Footer").destroy();
      $("body").removeClass("footer-loaded");
    }

    $("main").css("height", "");
    $("main").css("padding-bottom", "");

    setTimeout(function () {
      mainHeight = $("main").height();
      // console.log(mainHeight);
      // console.log( $(window).height() - $('header').height());
      // console.log($(window).height() - $('footer').height() - $('sticky-header').height());
      // if (isIndex() && !isMobile()) {
      //     $('main').css('height', mainHeight + 'px');
      // } else {
      // if (mainHeight <= $(window).height() - $('header').height()) {
      $("main").css(
        "min-height",
        "calc(100vh - " + $("sticky-header").height() + "px)",
      );
      // }

      setupFooter();

      if ($("footer").data("Footer")) {
        $("footer").data("Footer").load();
        $("body").addClass("footer-loaded");
        $("footer").show();
      }
      // }

      $("main").css("opacity", 1);
    }, 250);
  }

  window.refreshHeights = setMainHeight;

  function moveContent(menu, reval) {
    var id = menu.attr("id");
    var found = heights.find((x) => x.id == id);
    if (!found) return;

    if (!menu.hasClass("open") || reval) {
      setTimeout(function () {
        $("main").css("margin-top", found.height + padding - 80 + "px");
      }, 250);
    } else {
      $("main").css("margin-top", "");
    }
  }
})(jQuery);

function handleCloseGridCollapsible() {
  const collapsibleDom = $(".collapsible__more_info");
  if (collapsibleDom) {
    collapsibleDom.removeClass("active");
  }
}
// For grid collapsible GA
function initCollapsibleGA() {
  const mediaDom = $("[data-info]");
  if (!mediaDom.length) return;
  mediaDom.click((e) => {
    const dataInfo = e.currentTarget.dataset.info;
    if (dataInfo) {
      const moreInfoDom = $(`#${dataInfo}`);
      const moreInfoHeight = moreInfoDom.children("div").height();
      $(".collapsible__more_info").removeClass("active");
      moreInfoDom.toggleClass("active");
      moreInfoDom.css({
        height: moreInfoHeight + "px",
      });
    }
  });
}
